// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2fUiR","card":"style_card__1TDcN","cardInfo":"style_cardInfo__3pejE"};